// extracted by mini-css-extract-plugin
module.exports = {"card-stack":"CardStack_card-stack__2dA7E"};